var _style, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWilyaDarkPlain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-0.05 0 1952 720",
    style: {
      enableBackground: "new 0 0 2432.43 733.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FBB595;}\n\t.st2{fill:#D65818;}\n\t.st3{fill:#EA763B;}\n\t.st4{clip-path:url(#SVGID_00000059996053725628823740000017370778046638191785_);}\n\t.st5{clip-path:url(#SVGID_00000059996053725628823740000017370778046638191785_);fill:#FBB595;}\n\t.st6{clip-path:url(#SVGID_00000059996053725628823740000017370778046638191785_);fill:#D65818;}\n\t.st7{clip-path:url(#SVGID_00000059996053725628823740000017370778046638191785_);fill:#EA763B;}\n\t.st8{clip-path:url(#SVGID_00000059996053725628823740000017370778046638191785_);fill:#FFFFFF;}\n\t.st9{clip-path:url(#SVGID_00000101791263421437016540000016502593781142875054_);}\n\t.st10{clip-path:url(#SVGID_00000101791263421437016540000016502593781142875054_);fill:#FBB595;}\n\t.st11{clip-path:url(#SVGID_00000101791263421437016540000016502593781142875054_);fill:#D65818;}\n\t.st12{clip-path:url(#SVGID_00000101791263421437016540000016502593781142875054_);fill:#EA763B;}\n\t.st13{clip-path:url(#SVGID_00000101791263421437016540000016502593781142875054_);fill:#FFFFFF;}\n\t.st14{fill:#444444;}\n\t.st15{clip-path:url(#SVGID_00000130620753029680459250000001544315575979239604_);}\n\t.st16{clip-path:url(#SVGID_00000005962660737471712930000005134763114776394144_);}\n\t.st17{clip-path:url(#SVGID_00000005962660737471712930000005134763114776394144_);fill:#FBB595;}\n\t.st18{clip-path:url(#SVGID_00000005962660737471712930000005134763114776394144_);fill:#D65818;}\n\t.st19{clip-path:url(#SVGID_00000005962660737471712930000005134763114776394144_);fill:#EA763B;}\n\t.st20{clip-path:url(#SVGID_00000005962660737471712930000005134763114776394144_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1040.79,228.18h80.4l-121.2,296.4l-90.4-168.8l-90,168.8l-121.2-296.4h80l55.2,159.6l76-173.6l76.8,173.6L1040.79,228.18 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.18,228.18v280h-68.8v-280H1221.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.98,228.18v222h112.4v58h-180v-280H1347.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.38,228.18l-98,166v114h-68.8v-113.6l-98-166.4h77.6l54.8,105.2l54.8-105.2H1698.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.58,421.38l3.2,14.8l-34.8,72h-76.4l147.2-297.6l147.6,297.6h-76.8l-33.6-69.2l2.4-17.2l-39.6-90.8L1765.58,421.38z  M1736.38,402.58h138.8l4.4,51.6h-148L1736.38,402.58z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "2500,0 0,0 0,714.9 2500,714.9 2500,0  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119815238634849531390000001652548029687934897_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)"
    },
    d: "M541.74,714.87H141.76 c-2.5,0-4.52-2.02-4.52-4.52V313.88c0-2.5,2.02-4.52,4.52-4.52c2.5,0,4.52,2.02,4.52,4.52v391.95h390.95V34.24H246.93 c-2.5,0-4.52-2.02-4.52-4.52c0-2.5,2.02-4.52,4.52-4.52h294.81c2.5,0,4.52,2.02,4.52,4.52v680.63 C546.26,712.85,544.24,714.87,541.74,714.87L541.74,714.87z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)",
      fill: "#FBB595"
    },
    points: "4.47,191.99  125.69,4.52 489.4,159.67 292.87,380.77 4.47,191.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)",
      fill: "#D65818"
    },
    points: " 458.78,488.07 292.87,380.76 489.4,159.67 517.48,307.06 458.78,488.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)",
      fill: "#EA763B"
    },
    points: " 139.09,692.35 44.67,669.08 292.87,380.76 458.76,488.07 139.09,692.35  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)",
      fill: "#FFFFFF"
    },
    d: "M10.71,190.67 l281.38,184.17l189.76-213.49L127.42,10.17L10.71,190.67L10.71,190.67z M292.87,385.29c-0.86,0-1.72-0.24-2.48-0.74L1.99,195.78 c-2.08-1.36-2.67-4.15-1.32-6.24L121.9,2.07c1.2-1.85,3.54-2.57,5.57-1.7l363.71,155.15c1.34,0.57,2.32,1.75,2.64,3.17 c0.32,1.42-0.07,2.91-1.03,3.99l-196.53,221.1C295.37,384.77,294.13,385.29,292.87,385.29L292.87,385.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)",
      fill: "#FFFFFF"
    },
    d: "M299.75,379.82 l156.54,101.26l56.53-174.31l-26.14-137.23L299.75,379.82L299.75,379.82z M458.78,492.59c-0.86,0-1.71-0.25-2.45-0.72 L290.42,384.55c-1.11-0.71-1.84-1.88-2.03-3.19c-0.18-1.31,0.23-2.63,1.1-3.61l196.53-221.09c1.15-1.29,2.91-1.82,4.58-1.36 c1.66,0.46,2.92,1.82,3.24,3.51l28.08,147.39c0.14,0.75,0.09,1.52-0.14,2.24l-58.7,181.01c-0.43,1.33-1.46,2.39-2.78,2.86 C459.8,492.5,459.29,492.59,458.78,492.59L458.78,492.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)",
      fill: "#FFFFFF"
    },
    d: "M52.9,666.45 l85.4,21.05l312.12-199.45L293.73,386.69L52.9,666.45L52.9,666.45z M139.09,696.87c-0.36,0-0.72-0.04-1.08-0.13l-94.42-23.27 c-1.53-0.38-2.75-1.51-3.22-3.01c-0.48-1.5-0.15-3.13,0.88-4.33l248.21-288.32c1.47-1.7,3.98-2.07,5.88-0.85l165.89,107.31 c1.29,0.83,2.07,2.27,2.06,3.81c0,1.54-0.79,2.97-2.09,3.8L141.52,696.16C140.79,696.63,139.95,696.87,139.09,696.87 L139.09,696.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)"
    },
    d: "M259.57,29.72 c0,6.98-5.65,12.63-12.63,12.63c-6.98,0-12.64-5.65-12.64-12.63c0-6.98,5.66-12.63,12.64-12.63 C253.92,17.09,259.57,22.75,259.57,29.72L259.57,29.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000119815238634849531390000001652548029687934897_)"
    },
    d: "M154.38,314.41 c0,6.97-5.65,12.63-12.62,12.63c-6.98,0-12.64-5.66-12.64-12.63c0-6.98,5.66-12.63,12.64-12.63 C148.73,301.78,154.38,307.43,154.38,314.41L154.38,314.41z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWilyaDarkPlain);
export default __webpack_public_path__ + "static/media/logo_wilya_dark_plain.e67307734be5983e60ff9fd94a0cff4a.svg";
export { ForwardRef as ReactComponent };